const reserve = 'จองแล้ว';
const inProgress = 'กำลังดำเนินการ';
const success = 'เสร็จสิ้น';
const cancle = 'ยกเลิก';

export const WORD_DELIVERY_STATUS = { reserve, inProgress, success, cancle };

export const DELIVERY_STATUS = [reserve, inProgress, success, cancle];
